$(document).ready(function() {
    $('.grid-product__content').removeAttr('aria-hidden','true');
    $('br').attr('aria-hidden','true');
});
$(document).ready(function () {
    var thirdPartyLinks = $('main a');

    // Loop through each link
    thirdPartyLinks.each(function () {
        var link = $(this);
        var href = link.attr('href');

        // Skip links without href or with "javascript:void(0)"
        if (!href || href === 'javascript:void(0)') {
            return;
        }

        // Skip links without href or with "javascript:history.back()"
        if (!href || href === 'javascript:history.back()') {
            return;
        }

        // Skip links that contain an <img> element
        if (link.find('img').length > 0) {
            var img = link.find('img');

            // Check if the link is third-party
            if (isThirdParty(href)) {
                var altText = img.attr('alt') || ''; // Get alt text, default to an empty string if not present

                // Add a custom message to the alt text
                altText = altText ? altText + ', This link will open in a new tab' : 'This link will open in a new tab';

                img.attr('alt', altText); // Update the image's alt attribute
            }
            return; // Skip further processing for this link
        }

        // Check if the link leads to a third-party website
        if (isThirdParty(href)) {
            // Add the target="_blank" attribute
            link.attr('target', '_blank');
        }
    });

    // Function to check if a link is from a third-party website
    function isThirdParty(url) {
        // Skip empty or invalid URLs
        if (!url || typeof url !== 'string') return false;

        // Skip internal links that start with "/" or "#"
        if (url.startsWith('/') || url.startsWith('#')) return false;

        // Skip links that include the current domain
        if (url.includes('vegogarden.com')) return false;

        // All other cases are considered third-party
        return true;
    }
});

$(document).ready(function () {
    function setupDropdown(menuClass) {
        $(menuClass + ".has-dropdown>a").each(function () {
            $(this)
                .removeAttr("href")
                .attr("role", "button")
                .attr("tabindex", "0")
                .attr("aria-expanded", "false")
                .on("click", function (event) {
                    event.preventDefault(); // Prevent default anchor behavior

                    let expanded = $(this).attr("aria-expanded") === "true";

                    // Close all other dropdowns
                    $(".has-dropdown").removeClass("active-click");
                    $(".has-dropdown a").attr("aria-expanded", "false");

                    // Toggle the clicked dropdown
                    if (!expanded) {
                        $(this).attr("aria-expanded", "true");
                        $(this).closest(menuClass + ".has-dropdown").addClass("active-click");
                    }
                });
        });
    }

    const menus = [
        "li.menus-on-sale",
        ".menus-raised-garden-beds",
        ".menus-elevated-garden-beds",
        ".menus-ez-planters",
        ".menus-indoor-gardening",
        "li.menus-watering",
        "li.menus-composters.has-dropdown",
        ".menus-seed-starting",
        ".menus-accessories"
    ];

    // menus.forEach(setupDropdown);
});

// Close dropdown when clicking outside
$(document).on("click", function () {
    $(".has-dropdown").removeClass("active-click");
    $(".has-dropdown a").attr("aria-expanded", "false");
});

// Prevent closing when clicking inside the dropdown
$(".has-dropdown").on("click", function (event) {
    event.stopPropagation();
});
